import { AzureObject, AzureResponse } from '@/components/file-manager/azure-blob-storage/types'

export const isUrlResponse = (x: AzureResponse): x is AzureObject => {
  return (x as AzureObject).success !== undefined
}

export const calculatePath = (parentDirectoryPath: string, rootPath?: string) => {
  let path: string = parentDirectoryPath
  if (rootPath) {
    if (parentDirectoryPath === '') {
      console.log('path', rootPath)
      path = rootPath
    } else {
      console.log('path', rootPath + '/' + parentDirectoryPath)
      path = rootPath + '/' + parentDirectoryPath
    }
  }
  console.log('path', path)
  return path
}
